window.bootstrap = require("../bootstrap");

import './extend-prototype'

import './vue-app'

import './jquery-init'